// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import MKBadge from "components/MKBadge";

// Material Kit 2 PRO React examples
import Navbar from "components/Navbar";
import LandingPageHeader from "./LandingPageHeader";

import SimpleBlogCard from "examples/Cards/BlogCards/SimpleBlogCard";

// Coworking page sections
import Information from "pages/LandingPages/Coworking/sections/Information";
import Testimonials from "pages/LandingPages/Coworking/sections/Testimonials";
import AboutUs from "pages/LandingPages/Coworking/sections/AboutUs";

// Routes
import footerRoutes from "footer.routes";

// Images
import BRAVOPlatform from "assets/photos/BRAVOPlatform.png";
import Footer from "components/Footer";

function LandingPage() {
  return (
    <>
      <Navbar />
      <LandingPageHeader />
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" py={3}>
          <Container>
            <Grid
              container
              item
              flexDirection="column"
              alignItems="center"
              xs={12}
              lg={6}
              sx={{ textAlign: "center", mx: "auto" }}
            >
              <MKBadge
                variant="contained"
                color="info"
                badgeContent="Projects"
                container
                circular
                sx={{ mb: 1 }}
              />
              <MKTypography variant="h2" mb={1}>
                Current Active Projects {" "}
              </MKTypography>
              <MKTypography variant="body2" color="text">
                {"These are the projects that I am actively updating at the moment."}
              </MKTypography>
            </Grid>
            <Grid container spacing={3} sx={{ mt: 3 }}>
              <Grid item xs={12} md={6} lg={4}>
                <MKBox mt={3}>
                  <SimpleBlogCard
                    image={BRAVOPlatform}
                    title="BRAVO Platform"
                    description="Brain Recording Analysis and Visualization Online (BRAVO) is an online platform 
                                for processing neural recordings and other related data from sensing-enabled implanted neurostimulators."
                    action={{
                      type: "internal",
                      route: "/projects/bravo",
                      color: "dark",
                      label: "Read more",
                    }}
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
        
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <Footer />
      </MKBox>
    </>
  );
}

export default LandingPage;
